import React from "react";

import { Box, Button, Typography } from "@mui/material";

import ModernModal from "../../../common/ModernModal";
import { SharedEpisode } from "../../services/shared-episodes.service";

interface Props {
  sharedEpisode: SharedEpisode;
  handleClose: () => void;
  handleConfirm: () => void;
  open: boolean;
}

export default function ConfirmRevokeAccessToSharedEpisodeDialog({
  sharedEpisode,
  handleClose,
  handleConfirm,
  open,
}: Props) {
  return (
    <ModernModal
      open={open}
      onClose={handleClose}
      title="Revoke Access"
      maxWidth="sm"
      actions={
        <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleConfirm}>
            Revoke Access
          </Button>
        </Box>
      }
    >
      <Typography variant="body2" color="text.secondary">
        Are you sure you want to revoke access for{" "}
        <strong>{sharedEpisode.shared_with}</strong>? This action cannot be
        undone and they will no longer be able to access this episode.
      </Typography>
    </ModernModal>
  );
}
